module.exports = __webpack_public_path__ + "img/03.95252ce5.jpg";